import Repository from "./Repository";

const resource = "/code";

export default {
	check(code) {
		var endpoint = resource.concat('/:code').replace(':code', code);
		return Repository.get(endpoint);
	},
}